<kendo-window *ngIf="!loading && !isEmail" class="kendo-window" [top]="60" [width]="900" [height]="700"
    (close)="closeProgramDialog()" [state]="windowState">
    <kendo-window-titlebar>
        <div class="k-window-title">
            <h3 *ngIf="!isPrint && !isEmail && selectedServices.length === 1" class="ellipsis-text">
                {{selectedServices[0].name}}
            </h3>
            <h3 *ngIf="isPrint || isEmail" class="ellipsis-text">{{ 'COMMUNITY-PROVIDER-PROGRAM' | translate}}
            </h3>
        </div>
        <button kendoWindowMaximizeAction></button>
        <button kendoWindowRestoreAction></button>
        <button kendoWindowCloseAction></button>
    </kendo-window-titlebar>
    <div id="print-section">
        <div *ngFor="let service of selectedServices; let i = index;">
            <app-community-service-info-detail [service]="service" [i]="i" [servicesCount]="selectedServices.length"
                [reportImageUrl]="reportImageUrl">
            </app-community-service-info-detail>
        </div>
    </div>
    <kendo-dialog-actions style="position:absolute;margin-left:-16px" class="w-100 mt-3">
        <div class="row">
            <div class="col-6">
                <button #printBtn kendoButton printSectionId="print-section" [useExistingCss]="true"
                    ngxPrint (click)="closeProgramDialog()">
                    {{ 'PRINT' | translate}}<i class="fal fa-print"></i>
                </button>
                <button kendoButton *ngIf="memberEmail" (click)="generateAndSendEmail()">
                    {{ 'EMAIL' | translate}}<i class="fal fa-envelope"></i>
                </button>
                <button kendoButton *ngIf="memberSMS && communityPortalEnabled" (click)="generateAndSendSMS()">
                    {{ 'SMS' | translate}}<i class="fal fa-mobile"></i>
                </button>
            </div>
            <div class="col-6">
                <button kendoButton [primary]="true" type="button" (click)="closeProgramDialog()" class="float-right">
                    {{ 'CLOSE' | translate}}
                </button>
            </div>
        </div>
    </kendo-dialog-actions>
</kendo-window>
<!--Send by email version: Email subject, body and attachment-->
<span style="visibility: hidden;" #emailSubject>{{'COMMUNITY-RESOURCE-EMAIL-SUBJECT' | translate}}</span>
<span style="visibility: hidden;" #emailSMSBody>{{'COMMUNITY-RESOURCE-EMAIL-SMS-BODY' | translate}}</span>
<div *ngIf="isEmail">
    <div #emailBodyContent style="visibility: hidden;">
        <div *ngFor="let service of selectedServices; let i = index;">
            <span [ngClass]="{'pdf-pagebreak-before': i > 0}" style="font-size: 16;">{{service?.name}}</span>
            <span style="font-size: 10; color: #444444;" *ngIf="service?.organization">{{'BY' |
                translate}} {{service.organization.name}}</span>
            <table style="margin-top:-50" *ngIf="reportImageUrl">
                <tr>
                    <td style="border:none;width:80%"></td>
                    <td style="border:none;"><span><img [src]="reportImageUrl" style="height:40;width:100"></span>
                    </td>
                </tr>
            </table>
            <hr />
            <table>
                <tr *ngIf="service.formattedAddress !== ''">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{'ADDRESS' | translate}}</td>
                    <td style="border:none;">{{service.formattedAddress}}</td>
                </tr>
                <tr *ngIf="service.distance > 0">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{'DISTANCE' | translate}}</td>
                    <td style="border:none;">{{service.distance | number: '1.2-2'}}
                        {{formatDistanceLabel(service.distance)}}</td>
                </tr>
                <tr *ngIf="service.resourceStatus !== null && service.resourceStatus !== ''">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'RESOURCE-STATUS' | translate
                        }}</td>
                    <td style="border:none;">{{service.resourceStatus.displayName}}</td>
                </tr>
                <tr *ngIf="service.openingTimes !== null && service.openingTimes.length > 0">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'OPENED-ON' | translate }}</td>
                    <td style="border:none;">
                        <div *ngFor="let hour of service.openingTimes;">
                            <div>{{hour.day}} - {{hour.fromDate | date:'h:mm a'}} - {{hour.toDate | date:'h:mm a'}}
                            </div>
                        </div>
                    </td>
                </tr>
                <tr *ngIf="service.waitTimes !== null && service.waitTimes.length > 0">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'WAIT-TIMES' | translate }}
                    </td>
                    <td style="border:none;">
                        <div *ngFor="let wt of service.waitTimes;">
                            <span *ngIf="wt.locationID">{{wt.locationID}}&nbsp;-&nbsp;</span>
                            <span *ngIf="wt.waitTime">{{wt.waitTime}}</span>
                        </div>
                    </td>
                </tr>
                <tr *ngIf="service.description && service.description !== ''">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'DESCRIPTION' | translate }}
                    </td>
                    <td style="border:none;"><span [innerHTML]="service.description | replaceLineBreaks"></span></td>
                </tr>
                <tr *ngIf="service.alias !== null && service.alias !== ''">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'ALIAS' | translate }}</td>
                    <td style="border:none;"><span [innerHTML]="service.alias | replaceLineBreaks"></span></td>
                </tr>
                <tr *ngIf="service.eligibility && service.eligibility !== ''">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'ELIGIBILITY' | translate }}
                    </td>
                    <td style="border:none;"><span [innerHTML]="service.eligibility | replaceLineBreaks"></span></td>
                </tr>
                <tr *ngIf="service.cost && service.cost !== ''">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'COST' | translate }}</td>
                    <td style="border:none;"><span [innerHTML]="service.cost | replaceLineBreaks"></span></td>
                </tr>
                <tr *ngIf="service.websites !== null && service.websites.length > 0">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'WEBSITES' | translate }}</td>
                    <td style="border:none;">
                        <span *ngFor="let website of service.websites; let i=index;">
                            <span *ngIf="website.name">{{website.name}}&nbsp;-&nbsp;</span><span
                                *ngIf="website.url">{{website.url}}</span>
                        </span>
                    </td>
                </tr>
                <tr *ngIf="(service.programContactName !== null && service.programContactName !== '') ||
            (service.email !== null && service.email !== '') ||
            (service.phoneNumber !== null && service.phoneNumber !== '') ||
            (service.url !== null && service.url !== '') ||
            (service.faxNumber !== null && service.faxNumber !== '')">
                    <td style=" border:none;margin-left:-5;color:#444444;width:225px;">{{ 'PROGRAM-CONTACT' | translate
                        }}</td>
                    <td style="border:none;"><span
                            *ngIf="service.programContactName !== null && service.programContactName !== ''">{{service.programContactName}}<br /></span>
                        <span *ngIf="service.email !==null && service.email !==''">{{service.email}}<br /></span>
                        <span *ngIf="service.phoneNumber !== null && service.phoneNumber !==''">{{ 'PHONE' | translate
                            }}:&nbsp;{{service.phoneNumber |
                            phone}}<br /></span>
                        <span *ngIf="service.faxNumber !== null && service.faxNumber !==''">{{ 'FAX' | translate
                            }}:&nbsp;{{service.faxNumber |
                            phone}}<br /></span>
                        <span *ngIf="service.url !== null && service.url !==''">{{service.url}}</span>
                    </td>
                </tr>
                <tr *ngIf="(service.referralContactName !== null && service.referralContactName !== '') ||
                (service.referralEmail !== null && service.referralEmail !== '') ||
                (service.referralPhoneNumber !== null && service.referralPhoneNumber !== '') ||
                (service.referralUrl !== null && service.referralUrl !== '') ||
                (service.referralFaxNumber !== null && service.referralFaxNumber !== '') ||
                (service.referralEmergencyNumber !== null && service.referralEmergencyNumber !== '') ||
                (service.referralExtension !== null && service.referralExtension !== '')">
                    <td style=" border:none;margin-left:-5;color:#444444;width:225px;">{{ 'REFERRAL-CONTACT' | translate
                        }}</td>
                    <td style="border:none;"><span
                            *ngIf="service.referralContactName !== null && service.referralContactName !== ''">{{service.referralContactName}}<br /></span>
                        <span
                            *ngIf="service.referralEmail !==null && service.referralEmail !==''">{{service.referralEmail}}<br /></span>
                        <span *ngIf="service.referralPhoneNumber !== null && service.referralPhoneNumber !==''">{{
                            'PHONE' | translate
                            }}:&nbsp;{{service.referralPhoneNumber | phone}}<br /></span>
                        <span *ngIf="service.referralExtension !== null && service.referralExtension !==''">{{
                            'PHONE-EXTENSION' | translate
                            }}:&nbsp;{{service.referralExtension | phone}}<br /></span>
                        <span
                            *ngIf="service.referralEmergencyNumber !== null && service.referralEmergencyNumber !==''">{{
                            'EMERGENCY-NUMBER' | translate
                            }}:&nbsp;{{service.referralEmergencyNumber | phone}}<br /></span>
                        <span *ngIf="service.referralFaxNumber !== null && service.referralFaxNumber !==''">{{ 'FAX' |
                            translate }}:&nbsp;{{service.referralFaxNumber |
                            phone}}<br /></span>
                        <span
                            *ngIf="service.referralUrl !== null && service.referralUrl !==''">{{service.referralUrl}}</span>
                    </td>
                </tr>
                <tr *ngIf="service.languages !== null && service.languages.length > 0">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'LANGUAGES' | translate }}</td>
                    <td style="border:none;">
                        <span *ngFor="let language of service.languages; let i=index;"><span
                                *ngIf="i > 0">,&nbsp;</span>{{language.displayName}}</span>
                    </td>
                </tr>
                <tr *ngIf="service.alertDescription !== null && service.alertDescription !== ''">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'ALERT-DESCRIPTION' | translate
                        }}</td>
                    <td style="border:none;"><span [innerHTML]="service.alertDescription | replaceLineBreaks"></span>
                    </td>
                </tr>
                <tr *ngIf="service.applicationProcess !== null && service.applicationProcess !== ''">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'APPLICATION-PROCESS' |
                        translate }}</td>
                    <td style="border:none;"><span [innerHTML]="service.applicationProcess | replaceLineBreaks"></span>
                    </td>
                </tr>
                <tr *ngIf="service.capacity !== null && service.capacity !== ''">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'CAPACITY' | translate }}</td>
                    <td style="border:none;"><span [innerHTML]="service.capacity | replaceLineBreaks"></span>
                    </td>
                </tr>
                <tr *ngIf="service.documentationRequired !== null && service.documentationRequired !== ''">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'DOCUMENTATION-REQUIRED' |
                        translate }}</td>
                    <td style="border:none;"><span
                            [innerHTML]="service.documentationRequired | replaceLineBreaks"></span>
                    </td>
                </tr>
                <tr *ngIf="service.acceptingDisabledPatients !== null && service.acceptingDisabledPatients !== ''">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{'ACCEPTING-DISABLED-PATIENTS' |
                        translate:patientLabel}}</td>
                    <td style="border:none;">
                        <span *ngIf="service.acceptingDisabledPatients">{{ 'YES' | translate }}</span>
                        <span *ngIf="!service.acceptingDisabledPatients">{{ 'NO' | translate }}</span>
                    </td>
                </tr>
                <tr
                    *ngIf="service.acceptingElectronicReferrals !== null && service.acceptingElectronicReferrals !== ''">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{'ACCEPTING-ELECTRONIC-REFERRALS'
                        | translate}}
                    </td>
                    <td style="border:none;">
                        <span *ngIf="service.acceptingElectronicReferrals">{{ 'YES' | translate }}</span>
                        <span *ngIf="!service.acceptingElectronicReferrals">{{ 'NO' | translate }}</span>
                    </td>
                </tr>
                <tr *ngIf="service.acceptingNewPatients !== null && service.acceptingNewPatients !== ''">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{'ACCEPTING-NEW-PATIENTS' |
                        translate:patientLabel}}</td>
                    <td style="border:none;">
                        <span *ngIf="service.acceptingNewPatients">{{ 'YES' | translate }}</span>
                        <span *ngIf="!service.acceptingNewPatients">{{ 'NO' | translate }}</span>
                    </td>
                </tr>
                <tr *ngIf="service.acceptingSelfReferrals !== null && service.acceptingSelfReferrals !== ''">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{'ACCEPTING-SELF-REFERRALS' |
                        translate}}</td>
                    <td style="border:none;">
                        <span *ngIf="service.acceptingSelfReferrals">{{ 'YES' | translate }}</span>
                        <span *ngIf="!service.acceptingSelfReferrals">{{ 'NO' | translate }}</span>
                    </td>
                </tr>
                <tr *ngIf="service.lgbtq !== null && service.lgbtq !== ''">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{'LGBTQ' | translate}}</td>
                    <td style="border:none;">
                        <span *ngIf="service.lgbtq">{{ 'YES' | translate }}</span>
                        <span *ngIf="!service.lgbtq">{{ 'NO' | translate }}</span>
                    </td>
                </tr>
                <tr
                    *ngIf="service.submittingOrganization !== null && service.submittingOrganization.name !== null && service.submittingOrganization.name !== ''">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'SUBMITTING-ORGANIZATION' |
                        translate }}</td>
                    <td style="border:none;"><span
                            [innerHTML]="service.submittingOrganization.name | replaceLineBreaks"></span>
                    </td>
                </tr>
                <tr *ngIf="service.areaServedCities !== null && service.areaServedCities.length > 0">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'AREAS-SERVED-CITIES' |
                        translate }}</td>
                    <td style="border:none;">
                        <span *ngFor="let city of service.areaServedCities; let i=index;"><span
                                *ngIf="i > 0">,&nbsp;</span>{{city.displayName}}</span>
                    </td>
                </tr>
                <tr *ngIf="service.areaServedCounties !== null && service.areaServedCounties.length > 0">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'AREAS-SERVED-COUNTIES' |
                        translate }}</td>
                    <td style="border:none;">
                        <span *ngFor="let county of service.areaServedCounties; let i=index;"><span
                                *ngIf="i > 0">,&nbsp;</span>{{county.displayName}}</span>
                    </td>
                </tr>
                <tr *ngIf="service.areaServedZipCodes !== null && service.areaServedZipCodes.length > 0">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'AREAS-SERVED-ZIPCODES' |
                        translate }}</td>
                    <td style="border:none;">
                        <span *ngFor="let zip of service.areaServedZipCodes; let i=index;"><span
                                *ngIf="i > 0">,&nbsp;</span>{{zip.displayName}}</span>
                    </td>
                </tr>
                <tr *ngIf="service.incomeRequirements !== null && service.incomeRequirements.length > 0">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'INCOME-REQUIREMENTS' |
                        translate }}</td>
                    <td style="border:none;">
                        <span *ngFor="let income of service.incomeRequirements; let i=index;"><span
                                *ngIf="i > 0">,&nbsp;</span>{{income.displayName}}</span>
                    </td>
                </tr>
                <tr *ngIf="service.paymentMethods !== null && service.paymentMethods.length > 0">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'PAYMENT-METHODS' | translate
                        }}</td>
                    <td style="border:none;">
                        <span *ngFor="let method of service.paymentMethods; let i=index;">
                            <span *ngIf="i > 0">,&nbsp;</span>{{method.displayName}}</span>
                    </td>
                </tr>
                <!--Not rendering identifiers-->
                <tr *ngIf="service.licenses !== null && service.licenses.length > 0">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'LICENSES' | translate }}</td>
                    <td style="border:none;">
                        <span *ngFor="let license of service.licenses; let i=index;">
                            <span *ngIf="i > 0">,&nbsp;</span>{{license.displayName}}</span>
                    </td>
                </tr>
                <tr *ngIf="service.targetedPopulations !== null && service.targetedPopulations.length > 0">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'TARGETED-POPULATIONS' |
                        translate }}</td>
                    <td style="border:none;">
                        <span *ngFor="let population of service.targetedPopulations; let i=index;">
                            <span *ngIf="i > 0">,&nbsp;</span>{{population.displayName}}</span>
                    </td>
                </tr>
                <tr *ngIf="service.targetedDemographics !== null && service.targetedDemographics.length > 0">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'TARGETED-DEMOGRAPHICS' |
                        translate }}</td>
                    <td style="border:none;">
                        <span *ngFor="let demographic of service.targetedDemographics; let i=index;">
                            <span *ngIf="i > 0">,&nbsp;</span>{{demographic.displayName}}</span>
                    </td>
                </tr>
                <tr *ngIf="service.providerTaxonomies !== null && service.providerTaxonomies.length > 0">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'TAXONOMIES' | translate }}
                    </td>
                    <td style="border:none;">
                        <span *ngFor="let taxonomy of service.providerTaxonomies; let i=index;">
                            <span *ngIf="i > 0">,&nbsp;</span>{{taxonomy.displayName}}</span>
                    </td>
                </tr>
                <tr *ngIf="service.directoryManagerName !== null && service.directoryManagerName !== ''">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'DIRECTORY-MANAGER-NAME' |
                        translate
                        }}</td>
                    <td style="border:none;"><span
                            [innerHTML]="service.directoryManagerName | replaceLineBreaks"></span>
                    </td>
                </tr>
                <tr *ngIf="service.directoryManagerEmail !== null && service.directoryManagerEmail !== ''">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'DIRECTORY-MANAGER-EMAIL' |
                        translate
                        }}</td>
                    <td style="border:none;"><span
                            [innerHTML]="service.directoryManagerEmail | replaceLineBreaks"></span>
                    </td>
                </tr>
                <tr
                    *ngIf="service.directoryManagerNotificationPreference !== null && service.directoryManagerNotificationPreference !== ''">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{
                        'DIRECTORY-MANAGER-NOTIFICATION-PREFERENCE' |
                        translate
                        }}</td>
                    <td style="border:none;"><span
                            [innerHTML]="getNotificationPreference(service.directoryManagerNotificationPreference)"></span>
                    </td>
                </tr>
                <tr *ngIf="service.enhancedServices !== null && service.enhancedServices.length > 0">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'ENHANCED-SERVICES-OFFERED' |
                        translate }}</td>
                    <td style="border:none;">
                        <span *ngFor="let enhancedService of service.enhancedServices; let i=index;"><span
                                *ngIf="i > 0">,&nbsp;</span>{{enhancedService.displayName}}</span>
                    </td>
                </tr>
                <tr *ngIf="service.ableToConductScreenings !== null && service.ableToConductScreenings !== ''">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{'ABLE-TO-CONDUCT-SCREENINGS' |
                        translate}}</td>
                    <td style="border:none;">
                        <span *ngIf="service.ableToConductScreenings">{{ 'YES' | translate }}</span>
                        <span *ngIf="!service.ableToConductScreenings">{{ 'NO' | translate }}</span>
                    </td>
                </tr>
                <tr *ngIf="service.informationalOnly !== null && service.informationalOnly !== ''">
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{'INFORMATIONAL-ONLY' |
                        translate}}</td>
                    <td style="border:none;">
                        <span *ngIf="service.informationalOnly">{{ 'YES' | translate }}</span>
                        <span *ngIf="!service.informationalOnly">{{ 'NO' | translate }}</span>
                    </td>
                </tr>
                <tr>
                    <td style="border:none;margin-left:-5;color:#444444;width:225px;">{{ 'LAST-UPDATED' | translate }}
                    </td>
                    <td style="border:none;"><span [innerHTML]="service.lastModifiedOn | date:'longDate'"></span></td>
                </tr>
            </table>
        </div>
    </div>
</div>